import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import CreativeCircleCard from './CreativeCircleCard';

const creativeCirclesData = [
  {
    title: "Music",
    image: "https://images.pexels.com/photos/16803242/pexels-photo-16803242.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    description: "The Music Circle brings together musicians, producers, sound engineers, and DJs to collaborate, create, and elevate African music. Members share studio time, collaborate on tracks, organize live performances, and support each other's musical journeys. Whether you're into Afrobeats, Hip-Hop, Gospel, Jazz, or any other genre, this circle provides the connections and resources to amplify your sound."
  },
  {
    title: "Film",
    image: "https://images.pexels.com/photos/2059246/pexels-photo-2059246.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    description: "The Film Circle connects directors, cinematographers, editors, actors, and screenwriters to bring stories to life. Members network for productions, share equipment and locations, collaborate on short films and documentaries, and showcase their work at community screenings. From pre-production planning to post-production editing, this circle supports every stage of filmmaking."
  },
  {
    title: "Photography & Visual Arts",
    image: "https://images.pexels.com/photos/18034910/pexels-photo-18034910.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    description: "The Photography & Visual Arts Circle unites photographers, painters, graphic designers, and visual artists to explore, create, and exhibit together. Members organize group exhibitions, share techniques and equipment, collaborate on visual projects, and provide constructive feedback on each other's work. This circle celebrates all forms of visual expression and helps artists build their portfolios and reach new audiences."
  },
  {
    title: "Fashion & Modeling",
    image: "https://images.pexels.com/photos/33516897/pexels-photo-33516897.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    description: "The Fashion & Modeling Circle brings together designers, models, stylists, and fashion enthusiasts to shape the future of African fashion. Members collaborate on fashion shows, photoshoots, and lookbooks, network with industry professionals, and stay updated on trends and opportunities. Whether you're designing the next collection or walking the runway, this circle provides the platform to shine."
  },
  {
    title: "Dance & Movement",
    image: "https://images.pexels.com/photos/3622614/pexels-photo-3622614.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    description: "The Dance & Movement Circle connects dancers, choreographers, and movement artists across all styles—from Afro-fusion and contemporary to hip-hop and traditional dance. Members access practice spaces, organize performances and showcases, participate in movement workshops, and collaborate on creative projects. This circle celebrates the power of movement as a form of expression and storytelling."
  },
  {
    title: "Animation & Illustration",
    image: "https://images.pexels.com/photos/5088408/pexels-photo-5088408.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    description: "The Animation & Illustration Circle brings together animators, illustrators, and digital artists to push the boundaries of visual storytelling. Members share tools and software tips, collaborate on animated projects, participate in portfolio reviews, and explore opportunities in gaming, advertising, and entertainment. From 2D illustration to 3D animation, this circle supports artists at every skill level."
  },
  {
    title: "Content Creators & Influencers",
    image: "https://images.pexels.com/photos/8638581/pexels-photo-8638581.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    description: "The Content Creators & Influencers Circle connects YouTubers, podcasters, bloggers, and social media creators building audiences and brands online. Members collaborate on content, cross-promote each other's work, share growth strategies and analytics insights, and explore brand partnership opportunities. This circle helps creators amplify their reach and monetize their influence."
  },
  {
    title: "Writers",
    image: "https://images.pexels.com/photos/9909075/pexels-photo-9909075.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    description: "The Writers Circle brings together authors, poets, journalists, screenwriters, and storytellers to hone their craft and share their voices. Members participate in writing workshops, manuscript reviews, and critique sessions, explore publishing opportunities, and collaborate on anthologies and literary projects. Whether you write fiction, non-fiction, poetry, or scripts, this circle provides the support and feedback to elevate your writing."
  }
];

const ProjectTwo = () => {
  const sliderOptions = {
    loop: true,
    spaceBetween: 30,
    slidesPerView: 4,
    autoplay: {
      delay: 10000,
      disableOnInteraction: false,
    },
    pagination: {
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
      },
    },
  };

  return (
    <section className="project-two" id="projects">
      <div className="project-two__top">
        <div className="container">
          <div className="row">
            <div className="col-xl-7 col-lg-6">
              <div className="project-two__top-left">
                <div className="section-title text-left">
                  <div className="section-title__tagline-box">
                    <span className="section-title__tagline">Find Your Tribe</span>
                    <div className="section-title-shape">
                      <img src="assets/images/shapes/section-title-shape.png" alt="decorative shape" />
                    </div>
                  </div>
                  <h2 className="section-title__title">Our Creative Circles</h2>
                </div>
              </div>
            </div>
            <div className="col-xl-5 col-lg-6">
              <div className="project-two__top-right">
                <p className="project-two__top-text">Each major creative field is organized as a “C2 circle,” led by a Discipline Head to foster collaboration and growth.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="project-two__bottom">
        <div className="project-two__container">
          <Swiper {...sliderOptions} modules={[Autoplay, Pagination]} className="project-two__carousel">
            {creativeCirclesData.map((circle, index) => (
              <SwiperSlide key={index}>
                <CreativeCircleCard
                  image={circle.image}
                  title={circle.title}
                  description={circle.description}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default ProjectTwo;
